import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dateUtils from '@/utils/dateUtil';
import stationList from '@/utils/station';
import { getStationShiftCounters, createStationShiftCashierData, getStationDailyCounters, createStationDailyCashierData, createStationDailyPlatformData } from '@/api/bairun/financialCenter';
import { mapGetters } from 'vuex';
import NP from 'number-precision';
import PlatformDataExcelComponent from '@/components/PlatformDataExcel/index.vue';
export default {
  name: 'StationShift',
  components: {
    PlatformDataExcelComponent: PlatformDataExcelComponent
  },
  data: function data() {
    var _this = this;

    return {
      data: {},
      needShiftCashierDataDialog: false,
      needDailyCashierDataDialog: false,
      showShiftDiffDialog: false,
      showDailyDiffDialog: false,
      showModifyDailyPayDataDialog: false,
      payChannels: stationList.getDailyPayChannels(),
      showInsertDailyPayDataDialog: false,
      modifyDailyPayData: {
        dailyNo: '',
        stationId: 0,
        dailyInfoStatus: 1,
        dailyPayWayData: []
      },
      shiftCashierData: {
        shiftNo: '',
        shiftName: '',
        stationId: 0,
        shiftInfoStatus: 0,
        shiftPaywayList: []
      },
      dailyCashierDataRow: {},
      dailyCashierData: {
        dailyNo: '',
        dailyReportName: '',
        reportDate: '',
        stationId: 0,
        dailyInfoStatus: 0,
        dailyPayWayData: []
      },
      dailyShiftPayWayPayablesAmount: {},
      dailyShiftPayablesAmount: [0, 0, 0],
      dailyShiftPayablesAmountSum: 0,
      dailyCheckPaymentsAmount: [0, 0, 0],
      dailyCheckPaymentsAmountSum: 0,
      showShiftDiffData: {
        shiftNo: '',
        shiftName: '',
        stationId: 0,
        shiftPaywayList: []
      },
      showDailyDiffData: {
        dailyNo: '',
        dailyReportName: '',
        reportDate: '',
        stationId: 0,
        dailyPayWayData: []
      },
      shiftDiff: {
        stationAmount: 0,
        specialAmount: 0,
        platDiscount: 0,
        sellerDiscount: 0,
        cashAmount: 0,
        posAmount: 0,
        onlineAmount: 0,
        svcAmount: 0,
        walletAmount: 0,
        creditAmount: 0,
        accountAmount: 0,
        lossAmount: 0,
        loadometerAmount: 0,
        platAmount: 0,
        othersAmount: 0,
        shopAmount: 0,
        chargeAmount: 0,
        chargeBackAmount: 0,
        preStationSaleAmount: 0,
        preStationOilMass: 0,
        preStationAmount: 0,
        preStationDiscount: 0,
        diffAmount: 0,
        shiftInfoStatus: 0,
        remark: '',
        shiftNo: '',
        stationId: 0
      },
      dailyDiff: {
        stationAmount: 0,
        specialAmount: 0,
        platDiscount: 0,
        sellerDiscount: 0,
        cashAmount: 0,
        posAmount: 0,
        onlineAmount: 0,
        svcAmount: 0,
        walletAmount: 0,
        creditAmount: 0,
        accountAmount: 0,
        lossAmount: 0,
        loadometerAmount: 0,
        platAmount: 0,
        othersAmount: 0,
        shopAmount: 0,
        chargeAmount: 0,
        chargeBackAmount: 0,
        preStationSaleAmount: 0,
        preStationOilMass: 0,
        preStationAmount: 0,
        preStationDiscount: 0,
        diffAmount: 0,
        dailyInfoStatus: 0,
        remark: '',
        dailyNo: '',
        stationId: 0
      },
      shiftCounters: [],
      selectedStationId: 0,
      showAsyncStations: [],
      datePickerValue: dateUtils.todayTimestamp() * 1000,
      dailyShift: {
        dailyNo: 'DR',
        startTime: '-',
        endTime: '-',
        reportDate: dateUtils.timeStampToString(dateUtils.todayTimestamp(), 'YYYYMMDD'),
        shiftStatus: 0
      },
      excelReadDataDialog: false,
      excelReadGridData: [],
      excelReadGridHeader: [],
      excelReadDataTitle: '平台账单分析',
      filterRules: {
        '滴滴': {
          'platName': '滴滴',
          'platform': 2001,
          'headerRow': 6,
          'statusFiled': '订单状态',
          'successMap': {
            '已支付': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '数量',
          'totalFiled': '订单金额',
          'amountFiled': '折后金额(订单金额*折扣比例)',
          'sellerDiscountFiled': '商家券',
          'oilCodeField': '商品名称',
          'oilCodeSub': [0, -1]
        },
        '新滴': {
          'platName': '滴滴',
          'platform': 2001,
          'headerRow': 6,
          'statusFiled': '订单状态',
          'successMap': {
            '已支付': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '数量',
          'totalFiled': '订单金额',
          'amountFiled': '折后金额(订单金额*折扣比例)',
          'sellerDiscountFiled': '商家券',
          'saleDiscountFiled': '平台补贴',
          'oilCodeField': '商品名称',
          'oilCodeSub': [0, -1]
        },
        '货车': {
          'platName': '货车帮',
          'platform': 2002,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '支付成功': 1
          },
          'numsFiled': '数量(L/KG/m³)',
          'totalFiled': '加油/加气金额(元)',
          'amountFiled': '油站收款(元)',
          'oilCodeField': '品类',
          'oilCodeSub': [0, -4]
        },
        '易加': {
          'platName': '易加油',
          'platform': 2003,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '已支付': 1,
            '已退款': 1
          },
          'numsFiled': '升数(L)',
          'totalFiled': '订单原金额(元)',
          'amountFiled': '实收金额(元)',
          'oilCodeField': '油品',
          'oilCodeSub': [0, 2]
        },
        '团油': {
          'platName': '团油',
          'platform': 2004,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '已支付': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额(元）',
          'sellerDiscountFiled': '商家优惠金额(元）',
          'saleDiscountFiled': '让利金额(元）',
          'oilCodeField': '油号',
          'oilCodeSub': [0, -1]
        },
        '小象': {
          'platName': '小象',
          'platform': 2005,
          'headerRow': 0
        },
        '嗨卡': {
          'platName': '嗨卡',
          'platform': 2007,
          'headerRow': 0,
          'statusFiled': '支付状态',
          'successMap': {
            '支付成功': 1
          },
          'numsFiled': '油量(L)',
          'totalFiled': '油机金额',
          'amountFiled': '结算金额',
          'oilCodeField': '油号',
          'oilCodeSub': [0, -1]
        },
        '喂车': {
          'platName': '喂车',
          'platform': 2008,
          'headerRow': 0
        },
        '途虎': {
          'platName': '途虎',
          'platform': 2009,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '已支付': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额',
          'amountFiled': '加油应结算金额',
          'oilCodeField': '油号',
          'oilCodeSub': [0, -1]
        },
        '货拉': {
          'platName': '货拉拉',
          'platform': 2010,
          'headerRow': 0,
          'statusFiled': '账单类型',
          'successMap': {
            '消费': 1,
            '退还': -1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额',
          'amountFiled': '应结算金额',
          'oilCodeField': '油号',
          'oilCodeSub': [0, 0]
        },
        '佰思': {
          'platName': '佰思达',
          'platform': 2011,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '支付成功': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '升数',
          'totalFiled': '订单金额',
          'amountFiled': '门店结算金额',
          'oilCodeField': '油品',
          'oilCodeSub': [0, -1]
        },
        '爱车': {
          'platName': '爱车',
          'platform': 2012,
          'headerRow': 0,
          'statusFiled': '账单类型',
          'successMap': {
            '消费': 1,
            '退还': -1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额',
          'amountFiled': '应结算金额',
          'oilCodeField': '油号',
          'oilCodeSub': [0, 0]
        },
        '团油车队': {
          'platName': '团油车队',
          'platform': 2013,
          'headerRow': 0,
          'statusFiled': '账单类型',
          'successMap': {
            '消费': 1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额',
          'amountFiled': '应结算金额',
          'oilCodeField': '油号',
          'oilCodeSub': [0, -1]
        },
        '鲸车': {
          'platName': '鲸车惠',
          'platform': 2014,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '支付成功': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '升数',
          'totalFiled': '订单金额',
          'amountFiled': '门店结算金额',
          'sellerDiscountFiled': '门店结算优惠金额',
          'saleDiscountFiled': '佣金',
          'oilCodeField': '油品',
          'oilCodeSub': [0, -1]
        },
        '支付': {
          'platName': '刷脸付',
          'platform': 1008,
          'headerRow': 0,
          'statusFiled': '订单状态',
          'successMap': {
            '支付成功': 1,
            '退款中': -1,
            '退款失败': 1
          },
          'numsFiled': '升数',
          'totalFiled': '加油金额（元）',
          'amountFiled': '订单金额（元）',
          'oilCodeField': '油号',
          'oilCodeSub': [0, -1]
        }
      },
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 62 * 86400 * 1000 || pTime.getTime() > new Date();
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  watch: {},
  created: function created() {
    var _this2 = this;

    if (this.userInfo.sellerId > 0) {
      this.selectedStationId = this.userInfo.sellerId;
      this.showAsyncStations = this.asyncStations.filter(function (item) {
        return item.ID === _this2.userInfo.sellerId;
      });
    } else {
      this.showAsyncStations = this.asyncStations;
    }
  },
  methods: {
    absNumber: function absNumber(nums) {
      return Math.abs(nums);
    },
    normalDateTime: function normalDateTime(ts) {
      return dateUtils.normalFormat(ts);
    },
    getStationName: function getStationName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['stationName'];
        }
      }

      return '';
    },
    showShiftName: function showShiftName(shiftDate, shiftCurrent) {
      if (shiftCurrent === 1) {
        return String(shiftDate).substr(0, 4) + '年' + String(shiftDate).substr(4, 2) + '月' + String(shiftDate).substr(6, 2) + '日' + '早班（A）';
      } else if (shiftCurrent === 2) {
        return String(shiftDate).substr(0, 4) + '年' + String(shiftDate).substr(4, 2) + '月' + String(shiftDate).substr(6, 2) + '日' + '中班（B）';
      } else if (shiftCurrent === 3) {
        return String(shiftDate).substr(0, 4) + '年' + String(shiftDate).substr(4, 2) + '月' + String(shiftDate).substr(6, 2) + '日' + '晚班（C）';
      } else if (shiftCurrent === 99) {
        return String(shiftDate).substr(0, 4) + '年' + String(shiftDate).substr(4, 2) + '月' + String(shiftDate).substr(6, 2) + '日' + '交班日报';
      }

      return shiftCurrent;
    },
    loadData: function loadData() {
      var _this3 = this;

      if (this.selectedStationId < 1000) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.payChannels = stationList.getDailyPayChannels();
      this.dailyShiftPayWayPayablesAmount = {};
      this.dailyCheckPaymentsAmount = [0, 0, 0];
      this.dailyCheckPaymentsAmountSum = 0;
      this.dailyShiftPayablesAmount = [0, 0, 0];
      this.dailyShiftPayablesAmountSum = 0;
      getStationShiftCounters({
        shiftDate: this.datePickerValue,
        sellerId: this.selectedStationId
      }).then(function (response) {
        // console.log(response)
        _this3.shiftCounters = response.data;

        if (_this3.shiftCounters.length > 0) {
          var _that = _this3;
          _this3.dailyShift.shiftStatus = 0;
          _this3.dailyShift.startTime = '-';
          _this3.dailyShift.endTime = '-';

          _this3.shiftCounters.forEach(function (ele) {
            if (ele.shiftCurrent === 3 && ele.shiftStatus === 1) {
              _that.dailyShift.shiftStatus = 1;
            }

            if (ele.shiftCurrent === 1) {
              _that.dailyShift.startTime = _that.normalDateTime(ele.startDate);
              _that.dailyShift.reportDate = ele.shiftDate;
            }

            if (ele.shiftCurrent === 3 && ele.shiftStatus === 1) {
              _that.dailyShift.endTime = _that.normalDateTime(ele.endDate);
            }

            if (ele.shiftPayWayData.length > 0) {
              ele.shiftPayWayData.forEach(function (fn) {
                if (fn.payWay === 1001) {
                  _that.dailyShiftPayablesAmount[ele.shiftCurrent - 1] = fn.checkPayablesAmount;
                  _that.dailyShiftPayablesAmountSum = NP.plus(_that.dailyShiftPayablesAmountSum, fn.checkPayablesAmount);
                }

                if (fn.payWay === 1005 || fn.payWay === 1015 || fn.payWay === 1025 || fn.payWay === 1045 || fn.payWay === 1006) {
                  _that.dailyShiftPayWayPayablesAmount[fn.payWay] = NP.plus(_that.dailyShiftPayWayPayablesAmount[fn.payWay] || 0, fn.checkPayablesAmount);
                }
              });
            }
          });
        }
      });
      getStationDailyCounters({
        dailyDate: this.datePickerValue,
        sellerId: this.selectedStationId
      }).then(function (response) {
        // console.log(response)
        if (response.data.length > 0) {
          _this3.dailyCashierDataRow = response.data[0];

          if (_this3.dailyCashierDataRow.dailyPayWayData.length > 0) {
            var _that = _this3;

            _this3.dailyCashierDataRow.dailyPayWayData.forEach(function (el, index) {
              if (el.payWay === 1001) {
                var tempDailyCheckPaymentsAmount = _that.dailyCashierDataRow.dailyInfoStatus === 0 ? _that.dailyShiftPayablesAmount : el.checkPaymentsAmount.split('|');
                tempDailyCheckPaymentsAmount.push(0);
                tempDailyCheckPaymentsAmount.push(0);
                tempDailyCheckPaymentsAmount.push(0);
                _that.dailyCheckPaymentsAmount = tempDailyCheckPaymentsAmount.slice(0, 3);
              }

              if ((el.payWay === 1005 || el.payWay === 1015 || el.payWay === 1025 || el.payWay === 1045 || el.payWay === 1006) && _that.dailyCashierDataRow.dailyInfoStatus === 0) {
                _that.dailyCashierDataRow.dailyPayWayData[index]['checkPaymentsAmount'] = _that.dailyShiftPayWayPayablesAmount[el.payWay] || 0;
              }

              delete _that.payChannels[el.payWay];
            });

            _that.dailyCheckPaymentsAmountSum = _this3.npPlusArr(_that.dailyCheckPaymentsAmount);
          }
        }
      });
    },
    gotoReport: function gotoReport(row, path, cDate) {
      if (path === 'shiftDiff') {
        if (row.shiftInfoStatus === 0) {
          // 需填写线下交班金额
          this.shiftCashierData = {
            startDate: row.startDate,
            endDate: row.endDate,
            shiftNo: row.shiftNo,
            shiftName: this.showShiftName(row.shiftDate, row.shiftCurrent),
            stationId: row.stationId,
            shiftPaywayList: row.shiftPayWayData
          };
          this.needShiftCashierDataDialog = true;
          return;
        }

        this.showShiftDiffHandle(row);
        return;
      }

      if (path === 'dailyDiff') {
        if (row.dailyInfoStatus === 0) {
          this.dailyCashierData = {
            startDate: row.startDate,
            endDate: row.endDate,
            dailyNo: row.dailyNo,
            dailyReportName: this.showShiftName(row.reportDate, 99),
            reportDate: row.reportDate,
            stationId: row.stationId,
            dailyPayWayData: row.dailyPayWayData
          }; // this.dailyCheckPaymentsAmount = [0,0,0]

          this.needDailyCashierDataDialog = true;
          return;
        }

        this.showDailyDiffHandle(row);
      }
    },
    showShiftDiffHandle: function showShiftDiffHandle(row) {
      this.showShiftDiffData = {
        startDate: row.startDate,
        endDate: row.endDate,
        shiftNo: row.shiftNo,
        shiftName: this.showShiftName(row.shiftDate, row.shiftCurrent),
        stationId: row.stationId,
        shiftPaywayList: row.shiftPayWayData
      };
      this.shiftDiff = {
        stationAmount: 0,
        specialAmount: 0,
        platDiscount: 0,
        sellerDiscount: 0,
        cashAmount: 0,
        posAmount: 0,
        onlineAmount: 0,
        svcAmount: 0,
        walletAmount: 0,
        accountAmount: 0,
        creditAmount: 0,
        lossAmount: 0,
        loadometerAmount: 0,
        platAmount: 0,
        othersAmount: 0,
        shopAmount: 0,
        chargeAmount: 0,
        chargeBackAmount: 0,
        preStationSaleAmount: 0,
        preStationOilMass: 0,
        preStationAmount: 0,
        preStationDiscount: 0,
        diffAmount: 0,
        shiftInfoStatus: row.shiftInfoStatus,
        remark: row.remark,
        shiftNo: row.shiftNo,
        stationId: row.stationId
      };

      var _that = this;

      row.shiftPayWayData.forEach(function (el) {
        if (el.payWay > 2000 && el.payWay < 3000 && el.payWay !== 2006 || el.payWay === 1008) {
          _that.shiftDiff.platAmount = NP.plus(_that.shiftDiff.platAmount, el.checkPayablesAmount); // _that.shiftDiff.platDiscount = NP.plus(_that.shiftDiff.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount))
        }

        if (el.payWay === 1006 || el.payWay === 1009) {
          _that.shiftDiff.othersAmount = NP.plus(_that.shiftDiff.othersAmount, el.checkPayablesAmount);
        }

        if (el.payWay === 1001) {
          _that.shiftDiff.cashAmount = el.checkPayablesAmount > 0 ? el.checkPayablesAmount : 0;
        }

        if (el.payWay === 1005 || el.payWay === 1015 || el.payWay === 1025 || el.payWay === 1045) {
          _that.shiftDiff.posAmount = el.checkPayablesAmount ? NP.plus(_that.shiftDiff.posAmount, el.checkPayablesAmount) : _that.shiftDiff.posAmount;
        }

        if (el.payWay === 1003 || el.payWay === 1004 || el.payWay === 1013 || el.payWay === 1014 || el.payWay === 1023 || el.payWay === 1024) {
          _that.shiftDiff.onlineAmount = el.shiftReceivablesAmount ? NP.plus(_that.shiftDiff.onlineAmount, el.shiftReceivablesAmount) : _that.shiftDiff.onlineAmount;
        }

        if (el.payWay === 1002) {
          _that.shiftDiff.svcAmount = el.shiftStationAmount ? el.shiftStationAmount : 0;
        }

        if (el.payWay === 1010) {
          _that.shiftDiff.walletAmount = el.shiftStationAmount ? el.shiftStationAmount : 0;
        }

        if (el.payWay === 7002) {
          _that.shiftDiff.creditAmount = el.shiftStationAmount ? el.shiftStationAmount : 0;
        }

        if (el.payWay === 7005) {
          _that.shiftDiff.accountAmount = el.shiftStationAmount ? el.shiftStationAmount : 0;
        }

        if (el.payWay === 7001) {
          _that.shiftDiff.lossAmount = el.shiftReceivablesAmount ? el.shiftReceivablesAmount : 0;
        }

        if (el.payWay === 7005) {
          _that.shiftDiff.loadometerAmount = el.shiftReceivablesAmount ? el.shiftReceivablesAmount : 0;
        }

        _that.shiftDiff.shopAmount = NP.plus(_that.shiftDiff.shopAmount, el.shiftShopPaymentsAmount); // 使用shiftShopPaymentsAmount来计算便利店的实收，如果是便利店收银实际的差异则需用shiftShopAmount计算

        _that.shiftDiff.chargeAmount = NP.plus(_that.shiftDiff.chargeAmount, el.rechargeAmount);
        _that.shiftDiff.chargeBackAmount = NP.plus(_that.shiftDiff.chargeBackAmount, el.rechargeAmount < 0 ? el.rechargeAmount : 0);
        _that.shiftDiff.loadometerAmount = NP.plus(_that.shiftDiff.loadometerAmount, el.loadometerAmount);
        _that.shiftDiff.preStationSaleAmount = NP.plus(_that.shiftDiff.preStationSaleAmount, el.shiftPreStationSaleAmount);
        _that.shiftDiff.preStationOilMass = NP.plus(_that.shiftDiff.preStationOilMass, el.shiftPreStationOilMass);
        _that.shiftDiff.preStationAmount = NP.plus(_that.shiftDiff.preStationAmount, el.shiftPreStationAmount);
        _that.shiftDiff.preStationDiscount = NP.plus(_that.shiftDiff.preStationDiscount, el.shiftPreStationDiscount);
      });
      row.shiftGoodsData.forEach(function (el) {
        _that.shiftDiff.stationAmount = NP.plus(_that.shiftDiff.stationAmount, el.shiftPayablesAmount);
        _that.shiftDiff.specialAmount = NP.plus(_that.shiftDiff.specialAmount, el.shiftReturnPayablesAmount);
        _that.shiftDiff.specialAmount = NP.plus(_that.shiftDiff.specialAmount, el.shiftSelfPayablesAmount);
        _that.shiftDiff.specialAmount = NP.plus(_that.shiftDiff.specialAmount, el.shiftWarnPayablesAmount);
        _that.shiftDiff.sellerDiscount = NP.plus(_that.shiftDiff.sellerDiscount, el.shiftDiscountAmount);
      });
      this.showShiftDiffDialog = true;
    },
    showDailyDiffHandle: function showDailyDiffHandle(row) {
      this.showDailyDiffData = {
        startDate: row.startDate,
        endDate: row.endDate,
        dailyNo: row.dailyNo,
        reportDate: row.reportDate,
        dailyReportName: this.showShiftName(row.reportDate, 99),
        stationId: row.stationId,
        dailyPayWayData: row.dailyPayWayData
      };
      this.dailyDiff = {
        stationAmount: 0,
        specialAmount: 0,
        platDiscount: 0,
        sellerDiscount: 0,
        cashAmount: 0,
        posAmount: 0,
        onlineAmount: 0,
        svcAmount: 0,
        walletAmount: 0,
        creditAmount: 0,
        accountAmount: 0,
        lossAmount: 0,
        loadometerAmount: 0,
        platAmount: 0,
        othersAmount: 0,
        shopAmount: 0,
        chargeAmount: 0,
        chargeBackAmount: 0,
        preStationSaleAmount: 0,
        preStationOilMass: 0,
        preStationAmount: 0,
        preStationDiscount: 0,
        diffAmount: 0,
        dailyInfoStatus: row.dailyInfoStatus,
        remark: row.remark,
        dailyNo: row.dailyNo,
        stationId: row.stationId
      };

      var _that = this;

      row.dailyPayWayData.forEach(function (el) {
        if (el.payWay > 2000 && el.payWay < 3000 && el.payWay !== 2006 || el.payWay === 1008) {
          _that.dailyDiff.platAmount = NP.plus(_that.dailyDiff.platAmount, el.checkPaymentsAmount);
          _that.dailyDiff.platDiscount = NP.plus(_that.dailyDiff.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount));
        }

        if (el.payWay === 1006 || el.payWay === 1009) {
          _that.dailyDiff.othersAmount = NP.plus(_that.dailyDiff.othersAmount, el.checkPaymentsAmount);
        }

        if (el.payWay === 1001) {
          _that.dailyDiff.cashAmount = _that.dailyCheckPaymentsAmountSum ? NP.plus(_that.dailyDiff.cashAmount, _that.dailyCheckPaymentsAmountSum) : _that.dailyDiff.cashAmount;
        }

        if (el.payWay === 1005 || el.payWay === 1015 || el.payWay === 1025 || el.payWay === 1045) {
          _that.dailyDiff.posAmount = el.checkPaymentsAmount ? NP.plus(_that.dailyDiff.posAmount, el.checkPaymentsAmount) : _that.dailyDiff.posAmount;
        }

        if (el.payWay === 1003 || el.payWay === 1004 || el.payWay === 1013 || el.payWay === 1014 || el.payWay === 1023 || el.payWay === 1024) {
          _that.dailyDiff.onlineAmount = el.receivablesAmount ? NP.plus(_that.dailyDiff.onlineAmount, el.receivablesAmount) : _that.dailyDiff.onlineAmount;
        }

        if (el.payWay === 1002) {
          _that.dailyDiff.svcAmount = el.stationAmount ? NP.plus(_that.dailyDiff.svcAmount, el.stationAmount) : _that.dailyDiff.svcAmount;
        }

        if (el.payWay === 1010) {
          _that.dailyDiff.walletAmount = el.stationAmount ? NP.plus(_that.dailyDiff.walletAmount, el.stationAmount) : _that.dailyDiff.walletAmount;
        }

        if (el.payWay === 7002) {
          _that.dailyDiff.creditAmount = el.stationAmount ? NP.plus(_that.dailyDiff.creditAmount, el.stationAmount) : _that.dailyDiff.creditAmount;
        }

        if (el.payWay === 7005) {
          _that.dailyDiff.accountAmount = el.stationAmount ? NP.plus(_that.dailyDiff.accountAmount, el.stationAmount) : _that.dailyDiff.accountAmount;
        }

        if (el.payWay === 7001) {
          _that.dailyDiff.lossAmount = el.receivablesAmount ? NP.plus(_that.dailyDiff.lossAmount, el.receivablesAmount) : el.receivablesAmount;
        }

        _that.dailyDiff.shopAmount = NP.plus(_that.dailyDiff.shopAmount, el.shopPaymentsAmount); // 使用shopPaymentsAmount来计算便利店的实收，如果是便利店收银实际的差异则需用shopAmount计算

        _that.dailyDiff.chargeAmount = NP.plus(_that.dailyDiff.chargeAmount, el.rechargeAmount);
        _that.dailyDiff.chargeBackAmount = NP.plus(_that.dailyDiff.chargeBackAmount, el.rechargeAmount < 0 ? el.rechargeAmount : 0);
        _that.dailyDiff.loadometerAmount = NP.plus(_that.dailyDiff.loadometerAmount, el.loadometerAmount);
        _that.dailyDiff.preStationSaleAmount = NP.plus(_that.dailyDiff.preStationSaleAmount, el.preStationSaleAmount);
        _that.dailyDiff.preStationOilMass = NP.plus(_that.dailyDiff.preStationOilMass, el.preStationOilMass);
        _that.dailyDiff.preStationAmount = NP.plus(_that.dailyDiff.preStationAmount, el.preStationAmount);
        _that.dailyDiff.preStationDiscount = NP.plus(_that.dailyDiff.preStationDiscount, el.preStationDiscount);
      });
      row.dailyGoodsData.forEach(function (el) {
        if (el.sellerOrderType === 4) {
          return;
        }

        _that.dailyDiff.stationAmount = NP.plus(_that.dailyDiff.stationAmount, el.payablesAmount);
        _that.dailyDiff.specialAmount = NP.plus(_that.dailyDiff.specialAmount, el.returnPayablesAmount);
        _that.dailyDiff.specialAmount = NP.plus(_that.dailyDiff.specialAmount, el.selfPayablesAmount);
        _that.dailyDiff.specialAmount = NP.plus(_that.dailyDiff.specialAmount, el.warnPayablesAmount);
        _that.dailyDiff.sellerDiscount = NP.plus(_that.dailyDiff.sellerDiscount, el.discountAmount);
      });
      this.showDailyDiffDialog = true;
    },
    showModifyDailyPayData: function showModifyDailyPayData(dailyNo, stationId, row) {
      this.modifyDailyPayData.dailyNo = dailyNo;
      this.modifyDailyPayData.stationId = stationId;
      this.modifyDailyPayData.dailyPayWayData = [row];
      this.showModifyDailyPayDataDialog = true;
    },
    showInsertDailyPayData: function showInsertDailyPayData(status, dailyNo, stationId) {
      if (status === 0) {
        _Message({
          message: '当天班次进行中',
          type: 'warning',
          duration: 3 * 1000
        });

        return;
      } // console.log('showInsertDailyPayData', this.payChannels)


      this.modifyDailyPayData.dailyNo = dailyNo;
      this.modifyDailyPayData.stationId = stationId;
      this.modifyDailyPayData.dailyPayWayData = [{
        'dailyNo': dailyNo,
        'stationId': stationId,
        'payWay': parseInt(Object.keys(this.payChannels)[0]),
        'payWayName': Object.values(this.payChannels)[0],
        'checkPayablesAmount': 0,
        'checkPaymentsAmount': 0
      }];
      this.showInsertDailyPayDataDialog = true;
    },
    selectChange: function selectChange(payWay) {
      this.modifyDailyPayData.dailyPayWayData[0]['payWayName'] = this.payChannels[payWay];
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    npPlusArr: function npPlusArr(arr) {
      var res = 0;

      for (var i in arr) {
        // console.log('arr', i, arr.length, arr[i], Number(arr[i]))
        res = NP.plus(res, Number(arr[i]));
      }

      return res;
    },
    npMinus: function npMinus(value1, value2) {
      return NP.minus(value1, value2);
    },
    np3Minus: function np3Minus(value1, value2, value3) {
      return NP.minus(value1, value2, value3);
    },
    amountFormat: function amountFormat(value) {
      return NP.round(value, 2);
    },
    excelReadData: function excelReadData(row) {
      this.excelReadDataTitle = row.payWayName + '日账单Excel数据分析';
      this.excelReadDataDialog = true;
    },
    beforeUpload: function beforeUpload(files) {
      // console.log('beforeUpload', !files instanceof FileList, files)
      if (files.length === 0) {
        _Message({
          message: '上传文件解析失败',
          type: 'error',
          duration: 3 * 1000
        });

        return false;
      }

      var fileSize = 0;

      for (var i = 0; i < files.length; i++) {
        fileSize += files[i].size;
      }

      var isLt1M = fileSize / 1024 / 1024 < 5;

      if (isLt1M) {
        return true;
      }

      _Message({
        message: '上传文件过大',
        type: 'error',
        duration: 3 * 1000
      });

      return false;
    },
    handleSuccess: function handleSuccess(_ref) {
      var results = _ref.results,
          header = _ref.header;
      this.excelReadGridData = results;
      this.excelReadGridHeader = header;
    },
    doShiftCashierData: function doShiftCashierData() {
      var _this4 = this;

      if (this.shiftCashierData.shiftPaywayList.length === 0) {
        _Message({
          message: '当前还未完成交班',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.shiftCashierData.shiftInfoStatus = 1;
      createStationShiftCashierData(this.shiftCashierData).then(function (response) {
        // console.log(response)
        _this4.loadData();

        _this4.$notify({
          title: '成功',
          message: '录入成功',
          type: 'success',
          duration: 2000
        });

        _this4.needShiftCashierDataDialog = false;
      });
    },
    doDailyCashierData: function doDailyCashierData() {
      var _this5 = this;

      if (this.dailyCashierData.dailyPayWayData.length === 0) {
        _Message({
          message: '当天还有班次未交班',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      } // 处理现金数据


      var _that = this;

      if (this.dailyCashierData.dailyPayWayData.length > 0) {
        // // console.log('dailyCashierData ssssssss')
        this.dailyCashierData.dailyPayWayData.forEach(function (el, di) {
          // // console.log('dailyCashierData ttttt', di, el)
          if (el.payWay === 1001) {
            _that.dailyCashierData.dailyPayWayData[di]['checkPayablesAmount'] = _that.dailyCheckPaymentsAmount.join('|');
            _that.dailyCashierData.dailyPayWayData[di]['checkPaymentsAmount'] = _that.dailyCheckPaymentsAmount.join('|');
          } else if (el.payWay < 2000 && el.payWay !== 1008) {
            _that.dailyCashierData.dailyPayWayData[di]['checkPayablesAmount'] = String(el.checkPaymentsAmount);
            _that.dailyCashierData.dailyPayWayData[di]['checkPaymentsAmount'] = String(el.checkPaymentsAmount);
          } else {
            _that.dailyCashierData.dailyPayWayData[di]['checkPayablesAmount'] = String(el.checkPayablesAmount);
            _that.dailyCashierData.dailyPayWayData[di]['checkPaymentsAmount'] = String(el.checkPaymentsAmount);
          }
        });
      } // console.log('dailyCashierData', this.dailyCashierData)


      this.dailyCashierData.dailyInfoStatus = 1;
      createStationDailyCashierData(this.dailyCashierData).then(function (response) {
        // console.log('createStationDailyCashierData' + response.data)
        _this5.loadData();

        _this5.$notify({
          title: '成功',
          message: '录入成功',
          type: 'success',
          duration: 2000
        });

        _this5.needDailyCashierDataDialog = false;
      });
    },
    doModifyDailyPayData: function doModifyDailyPayData() {
      var _this6 = this;

      if (this.modifyDailyPayData.dailyPayWayData.length === 0) {
        _Message({
          message: '修正数据为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.modifyDailyPayData.dailyPayWayData[0]['payWay'] === 0) {
        _Message({
          message: '修正数据的支付方式不能为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      } // 处理现金数据


      var _that = this;

      if (this.modifyDailyPayData.dailyPayWayData.length > 0) {
        // // console.log('dailyCashierData ssssssss')
        this.modifyDailyPayData.dailyPayWayData.forEach(function (el, di) {
          // // console.log('dailyCashierData ttttt', di, el)
          if (el.payWay === 1001) {
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPayablesAmount'] = _that.dailyCheckPaymentsAmount.join('|');
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPaymentsAmount'] = _that.dailyCheckPaymentsAmount.join('|');
          } else if (el.payWay < 2000 && el.payWay !== 1008) {
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPayablesAmount'] = String(el.checkPaymentsAmount);
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPaymentsAmount'] = String(el.checkPaymentsAmount);
          } else {
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPayablesAmount'] = String(el.checkPayablesAmount);
            _that.modifyDailyPayData.dailyPayWayData[di]['checkPaymentsAmount'] = String(el.checkPaymentsAmount);
          }
        });
      } // console.log('modifyDailyPayData', this.modifyDailyPayData)


      createStationDailyCashierData(this.modifyDailyPayData).then(function (response) {
        // console.log('createStationDailyCashierData' + response.data)
        _this6.loadData();

        _this6.$notify({
          title: '成功',
          message: '修正成功',
          type: 'success',
          duration: 2000
        });

        _this6.showModifyDailyPayDataDialog = false;
        _this6.showInsertDailyPayDataDialog = false;
        _this6.showDailyDiffDialog = false;
      });
    },
    submitShiftRemark: function submitShiftRemark(shiftNo, stationId, shiftInfoStatus, remark) {
      var _this7 = this;

      if (shiftNo === '' || stationId === 0) {
        _Message({
          message: '缺少班次信息',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (shiftInfoStatus !== 1) {
        _Message({
          message: '当前还未录入收银数据',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      createStationShiftCashierData({
        'shiftNo': shiftNo,
        'stationId': stationId,
        'shiftInfoStatus': 2,
        'remark': remark
      }).then(function (response) {
        // console.log(response)
        _this7.loadData();

        _this7.showShiftDiffDialog = false;

        _this7.$notify({
          title: '成功',
          message: '提交说明成功',
          type: 'success',
          duration: 2000
        });
      });
    },
    submitDailyRemark: function submitDailyRemark(dailyNo, stationId, dailyInfoStatus, remark) {
      var _this8 = this;

      if (dailyNo === '' || stationId === 0) {
        _Message({
          message: '缺少日报信息',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (dailyInfoStatus !== 1) {
        _Message({
          message: '当前还未录入核对数据',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      createStationDailyCashierData({
        'dailyNo': dailyNo,
        'stationId': stationId,
        'dailyInfoStatus': 2,
        'remark': remark
      }).then(function (response) {
        // console.log(response)
        _this8.loadData();

        _this8.showDailyDiffDialog = false;

        _this8.$notify({
          title: '成功',
          message: '提交说明成功',
          type: 'success',
          duration: 2000
        });
      });
    },
    submitDailyPlatformData: function submitDailyPlatformData() {
      var _this9 = this;

      if (this.excelReadGridData.length === 0) {
        _Message({
          message: '当前还未上传有效的平台数据',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      var noUpData = 1;

      for (var i in this.excelReadGridData) {
        if (!this.excelReadGridData[i]['ID']) {
          noUpData = 0;
        } else {
          this.excelReadGridData[i]['ID'] = parseInt(this.excelReadGridData[i]['ID']);
        }

        this.excelReadGridData[i]['nums'] = parseFloat(this.excelReadGridData[i]['nums']);
        this.excelReadGridData[i]['total'] = parseFloat(this.excelReadGridData[i]['total']);
        this.excelReadGridData[i]['amount'] = parseFloat(this.excelReadGridData[i]['amount']);
        this.excelReadGridData[i]['discount'] = parseFloat(this.excelReadGridData[i]['discount']);
        this.excelReadGridData[i]['nums92'] = parseFloat(this.excelReadGridData[i]['nums92']);
        this.excelReadGridData[i]['total92'] = parseFloat(this.excelReadGridData[i]['total92']);
        this.excelReadGridData[i]['amount92'] = parseFloat(this.excelReadGridData[i]['amount92']);
        this.excelReadGridData[i]['discount92'] = parseFloat(this.excelReadGridData[i]['discount92']);
        this.excelReadGridData[i]['nums95'] = parseFloat(this.excelReadGridData[i]['nums95']);
        this.excelReadGridData[i]['total95'] = parseFloat(this.excelReadGridData[i]['total95']);
        this.excelReadGridData[i]['amount95'] = parseFloat(this.excelReadGridData[i]['amount95']);
        this.excelReadGridData[i]['discount95'] = parseFloat(this.excelReadGridData[i]['discount95']);
        this.excelReadGridData[i]['nums0'] = parseFloat(this.excelReadGridData[i]['nums0']);
        this.excelReadGridData[i]['total0'] = parseFloat(this.excelReadGridData[i]['total0']);
        this.excelReadGridData[i]['amount0'] = parseFloat(this.excelReadGridData[i]['amount0']);
        this.excelReadGridData[i]['discount0'] = parseFloat(this.excelReadGridData[i]['discount0']);
        this.excelReadGridData[i]['stationId'] = parseInt(this.excelReadGridData[i]['stationId']);
        this.excelReadGridData[i]['dailyDate'] = parseInt(this.excelReadGridData[i]['dailyDate']);
        this.excelReadGridData[i]['platform'] = parseInt(this.excelReadGridData[i]['platform']);
      }

      console.log('submitDailyPlatformData', this.excelReadGridData);

      if (noUpData > 0) {
        _Message({
          message: '当前还未上传有效的平台数据',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      createStationDailyPlatformData(this.excelReadGridData).then(function (response) {
        // console.log(response)
        _this9.$notify({
          title: '成功',
          message: '上传平台数据成功',
          type: 'success',
          duration: 2000
        });

        _this9.loadData();

        _this9.excelReadDataDialog = false;
      });
    },
    deleteOnePlatformData: function deleteOnePlatformData(row) {
      var _this10 = this;

      if (this.userInfo.authorityId !== '888' && this.userInfo.authorityId !== '9994' && this.userInfo.authorityId !== '9990') {
        this.$notify({
          title: '禁止操作',
          message: '请联系财务或系统管理员',
          type: 'error',
          duration: 2000
        });
        return;
      } // console.log('deleteOnePlatformData row', row)


      row.status = 1;
      createStationDailyPlatformData([row]).then(function (response) {
        // console.log(response)
        _this10.$notify({
          title: '成功',
          message: '删除平台数据成功',
          type: 'success',
          duration: 2000
        });

        _this10.loadData();

        _this10.excelReadDataDialog = false;
      });
    }
  }
};